import styled from "@emotion/styled";
import { ScrollViewProps } from "@src/ruix/types";
import React from "react";

const ScrollViewContainer = styled.div<ScrollViewProps>`
	width: ${({ width }) => width || "100%"};
	height: ${({ height }) => height || "100%"};
	background-color: ${({ backgroundColor }) => backgroundColor || "transparent"};
	overflow: auto;
	padding: 10px;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

	/* Custom scrollbar styles */
	/* &::-webkit-scrollbar {
		width: 8px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	&::-webkit-scrollbar-thumb {
		background: #888;
		border-radius: 4px;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: #555;
	} */
`;

const ScrollView: React.FC<ScrollViewProps> = ({ width, height, backgroundColor, children }) => (
	<ScrollViewContainer width={width} height={height} backgroundColor={backgroundColor}>
		{children}
	</ScrollViewContainer>
);

export default ScrollView;
